import React, { useState, useCallback } from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import LoginModal from './LoginModal';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; 
import SignupModal from './SignupModal';
import { useDispatch } from 'react-redux';
import { clearError } from '../actions/userActions';

const NavigationBar = () => {
    
    const [loginModalShow, setLoginModalShow] = useState(false);
    const [signupModalShow, setSignupModalShow] = useState(false);
    const dispatch = useDispatch();

    const handleHideLogIn = useCallback(() => {       
        setLoginModalShow(false);
        dispatch(clearError());
    }, [dispatch]);
    
    const handleHideSignUp = useCallback(() => {       
        setSignupModalShow(false);
        dispatch(clearError());
    }, [dispatch]);

    const handleLoginToSignup = useCallback(() => {
        setLoginModalShow(false);
        setSignupModalShow(true);
        dispatch(clearError());
    }, [dispatch]);

    return (
        <>
        <header className="landing_nav">
            <Navbar expand="lg" className='justify-content-between' style={{width: '100%'}}>
                <Navbar.Brand as={Link} to="/">
                    <div className="logo">
                        <img src={logo} alt="UAI microcredenciales" />
                    </div>
                </Navbar.Brand>
                <Nav className="justify-content-end align-items-center" style={{ gap: "10px" }}>
                    <Button
                        id="signup-link"
                        style={{marginRight:'10px'}}
                        onClick={() => setSignupModalShow(true)}
                        variant='link'
                    >
                        ¿Sos externo y no tenes cuenta?
                    </Button>

                    <Button
                        id="logIn"
                        className="btn btn-primary" style={{marginRight:'10px'}}
                        onClick={() => setLoginModalShow(true)}
                    >
                        Iniciar sesión
                    </Button>
                </Nav>
            </Navbar>
            <LoginModal show={loginModalShow} onHide={handleHideLogIn} onOpenSignup={handleLoginToSignup} />
            <SignupModal show={signupModalShow} onHide={handleHideSignUp} />
            </header>
        </>
    );
};

export default NavigationBar;
